// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"9980b0e8","447":"fdf9edac","888":"ff5303b7","967":"6a23876e"}[chunkId] + ".chunk.js";
};